<script>
/**
 * ****************************************************************************
 * @description     :   Select Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash';
import uuid from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of select component
 */
var AnsSelect = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: String | Number,
        modelValue: String | Number,
        emptyText: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        isFromSearch: {
            type: Boolean,
            default: false
        },
        removeEmptyOption: {
            type: Boolean,
            default: false
        },
        options: Array,
        onChangeEvent: Function,
        onFocus: Function,
        onBlur: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: uuid.uuid()
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        }
    },
    computed: {
        vewValue() {
            const val = this.modelValue ? this.modelValue : this.value;
            return val;
        },
        listOptions() {
            if (this.removeEmptyOption) {
                return this.options ?? [];
            }
            if (!this.options) {
                return [
                    {
                        code: '',
                        name: ''
                    }
                ];
            }
            const idx = _.findIndex(this.options, function (o) {
                return (
                    !o.name ||
                    `${o.name}`.trim() === '' ||
                    `${o.name}`.trim() === 'すべて' ||
                    `${o.name}`.trim() === '全て'
                );
            });
            if (idx < 0 && !this.removeEmptyOption) {
                this.options.unshift({
                    code: '',
                    name: ''
                });
            }
            return this.options ?? [];
        }
    },
    methods: {
        /**
         * event forcus on select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * click update item for select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            const oldValue = this.vewValue;
            const newValue = this.$refs.select.value;
            if ((this.vewValue ?? '') != (newValue ?? '')) {
                this.$emit('update:modelValue', newValue);
                if (this.onChangeEvent) {
                    this.onChangeEvent(e, newValue, oldValue);
                }
            }
        }
    }
};
export default AnsSelect;
</script>
